import Repository from './Repository';

const resource = '/units';

export default {
  /**
   * Get Opd Name List
   * @param {object} params
   *
   * @property {string} q - filter opd name by
   * @property {number, string} per_page - how many opd data to show
   * @property {number, string} page - filter opd by page number
   *
   * Get OPD list
   * @returns {Promise}
   */
  getUnitLists(params = {}) {
    return Repository.get(`${resource}`, { params });
  },

  /**
   * get unit by unit ID
   * @param {number} id - ID of the unit
   *
   * @returns {Promise}
   */
  getUnitById(id = null) {
    return Repository.get(`${resource}/${id}`);
  },

  /**
   * Store Unit
   * @returns {Promise}
   */
  createUnit(body) {
    return Repository.post(`${resource}`, body);
  },

  /**
   * update Unit
   * @param {object} body - form request body
   * @param {number} id - ID of the unit

   * @returns {Promise}
   */
  updateUnit(body, id = null) {
    return Repository.put(`${resource}/${id}`, body);
  },

  /**
   * Delete unit by unit ID
   * @param {number} id - ID of the unit
   *
   * @returns {Promise}
   */
  deleteUnitById(id = null) {
    return Repository.delete(`${resource}/${id}`);
  },
};
